module.exports = __webpack_public_path__ + "img/line-sc.912e2fab.svg";